import src from '../assets/swing365-dark.png';
import { imageLogo } from './imageLogo';

/**
 * Swing 365 — dark-surface wordmark: teal S icon + white "SWING | 365" + teal "GOLF"
 * on transparency. For use on the branded canvas only — invisible on light surfaces.
 */
export const Swing365DarkLogo = imageLogo({
  src,
  width: 617,
  height: 156,
  alt: 'Swing 365',
});
